<template>
	<div  class="editor section-description">

		<editor-menu-bubble class="menububble" :editor="editor" @hide="hideLinkMenu">
			<div
			slot-scope="{ commands, isActive, getMarkAttrs, menu }"
			class="menububble"
			:class="{ 'is-active': menu.isActive }"
			:style="`left: ${menu.left}px; bottom: ${menu.bottom}px;`"
			>
			<button
			class="menubar__button"
			:class="{ 'is-active': isActive.heading({ level: 2 }) }"
			@click="commands.heading({ level: 2 })"
			>
			H2
		</button>

		<button
		class="menubar__button"
		:class="{ 'is-active': isActive.heading({ level: 3 }) }"
		@click="commands.heading({ level: 3 })"
		>
		H3
	</button>
	<button
	class="menubar__button"
	:class="{ 'is-active': isActive.bold() }"
	@click="commands.bold"
	>
	<i class="fa fa-bold" aria-hidden="true"></i>
</button>

<button
class="menubar__button"
:class="{ 'is-active': isActive.italic() }"
@click="commands.italic"
>
<i class="fa fa-italic" aria-hidden="true"></i>
</button>

<button
class="menubar__button"
:class="{ 'is-active': isActive.strike() }"
@click="commands.strike"
>
<i class="fa fa-strikethrough" aria-hidden="true"></i>
</button>

<button
class="menubar__button"
:class="{ 'is-active': isActive.underline() }"
@click="commands.underline"
>
<i class="fa fa-underline" aria-hidden="true"></i>
</button>

<button
class="menubar__button"
:class="{ 'is-active': isActive.code() }"
@click="commands.code"
>
<i class="fa fa-code" aria-hidden="true"></i>
</button>

<button
class="menubar__button"
:class="{ 'is-active': isActive.paragraph() }"
@click="commands.paragraph"
>
<i class="fa fa-paragraph" aria-hidden="true"></i>
</button>





<button
class="menubar__button"
:class="{ 'is-active': isActive.bullet_list() }"
@click="commands.bullet_list"
>
<i class="fa fa-list-ul" aria-hidden="true"></i>
</button>

<button
class="menubar__button"
:class="{ 'is-active': isActive.ordered_list() }"
@click="commands.ordered_list"
>
<i class="fa fa-list-ol" aria-hidden="true"></i>
</button>

<button
class="menubar__button"
:class="{ 'is-active': isActive.blockquote() }"
@click="commands.blockquote"
>
<i class="fa fa-quote-right" aria-hidden="true"></i>
</button>

<button
class="menubar__button"
:class="{ 'is-active': isActive.code_block() }"
@click="commands.code_block"
>
<i class="fa fa-code" aria-hidden="true"></i>
</button>

<button
class="menubar__button"
@click="commands.horizontal_rule"
>
<i class="fa fa-window-minimize" aria-hidden="true"></i>
</button>

<button
class="menubar__button"
@click="commands.undo"
>
<i class="fa fa-undo" aria-hidden="true"></i>
</button>

<button
class="menubar__button"
@click="commands.redo"
>
<i class="fa fa-repeat" aria-hidden="true"></i>
</button>

</span>
<form class="menububble__form" v-if="linkMenuIsActive" @submit.prevent="setLinkUrl(commands.link, linkUrl)">
	<input class="menububble__input" type="text" v-model="linkUrl" placeholder="https://" ref="linkInput" @keydown.esc="hideLinkMenu"/>
	<button class="menububble__button" @click="setLinkUrl(commands.link, null)" type="button">
		<i class="fa fa-trash-o" aria-hidden="true"></i>
	</button>
</form>

<template v-else>
	<button
	class="menububble__button"
	@click="showLinkMenu(getMarkAttrs('link'))"
	:class="{ 'is-active': isActive.link() }"
	>
	<span>{{ isActive.link() ? 'Update Link' : 'Добави link'}}</span>
	<i class="fa fa-link" aria-hidden="true"></i>
</button>
</template>

<button
class="menubar__button"
@click="customEditorCss('float','left')"
>
Float:left
</button>

<button
class="menubar__button"
@click="customEditorCss('float','right')"
>
Float:right
</button>

<button
class="menubar__button"
@click="customEditorClass('description-image-border')"
>
border
</button>

<button
class="menubar__button"
@click="commands.redo"
>
<i class="fa fa-repeat" aria-hidden="true"></i>
</button>

<input v-if="sizeMenuActive" class="menububble__input" type="text" v-model="sizeValue" placeholder="10%" @keyup.enter="changeSizeImage"  @keydown.esc="sizeMenuActive =false"/>


<button v-else
class="menububble__button"
@click="sizeMenuActive = true"
:class="{ 'is-active': isActive.link() }"
>
<span>Измени размер</span>
<i class="fa fa-compress" aria-hidden="true"></i>
</button>

</div>
</editor-menu-bubble>
<editor-menu-bar :editor="editor">
	<div class="menubar" slot-scope="{ commands, isActive }">
		<div class="toolbar">


			<button
			class="menubar__button"
			@click="commands.createTable({rowsCount: 3, colsCount: 3, withHeaderRow: false })"
			>
			<span>Добави таблица</span>

		</button>

		<span v-if="isActive.table()">
			<button
			class="menubar__button"
			@click="commands.deleteTable"
			>
			<span>Изтрий таблица</span>
		</button>
		<button
		class="menubar__button"
		@click="commands.addColumnBefore"
		>
		<span>Добави поле от дясно</span>
	</button>
	<button
	class="menubar__button"
	@click="commands.addColumnAfter"
	>
	<span>Добави поле от ляво</span>
</button>
<button
class="menubar__button"
@click="commands.deleteColumn"
>
<span>Изтрий поле дясно</span>
</button>
<button
class="menubar__button"
@click="commands.addRowBefore"
>
</button>
<button
class="menubar__button"
@click="commands.addRowAfter"
>
<span>Добави поле долу</span>

</button>
<button
class="menubar__button"
@click="commands.deleteRow"
>
<span>изтрий поле</span>
</button>
<button
class="menubar__button"
@click="commands.toggleCellMerge"
>
</button>
</span>
</div>
</div>
</editor-menu-bar> 
<!--  <div class="input-div">
         <input type="text"  v-model="metaLink" class="input" >
         <span data-v-303a1d7c="" class="footer-input">Meta Title | Символи: {{ countChars(metaLink) }}</span>
     </div> -->


     <editor-content class="editor__content" :editor="editor" />
 </div>
</template>

<script>
	import { Editor, EditorContent, EditorMenuBar,EditorMenuBubble  } from 'tiptap'
	import {
		Blockquote,
		CodeBlock,
		HardBreak,
		Heading,
		HorizontalRule,
		OrderedList,
		BulletList,
		ListItem,
		TodoItem,
		TodoList,
		Bold,
		Image,

		Code,
		Italic,
		Link,
		Strike,
		Underline,
		History,

		Table,
		TableHeader,
		TableCell,
		TableRow,
	} from 'tiptap-extensions'


	export default {
		name: 'editor',

		props: {
			contentt: {
				type: String,
			}
		},
		watch: {
			contentt(data) {
				if(this.countUpdateContent == 0 && this.$route.params.id) {

					// var htmlObject = data.toHtmlObject
					// console.log(htmlObject)
					this.setContent(data)

					var el = document.createElement( 'html' );
					el.innerHTML = "<html><head><title>titleTest</title></head><body>"+ data +"</body></html>";

					var oldImgs = el.getElementsByTagName('img')

					var newImgs = document.getElementsByClassName('ProseMirror')
					newImgs = newImgs[0].getElementsByTagName('img')

					// this.removeClassFromHtml('ProseMirror-selectednode')  

					for (var i = 0; i <= oldImgs.length -1; i++) {

						// console.log('image #'+i+' - ' + oldImgs[i].className)

						if(oldImgs[i].style.float != '') {
							newImgs[i].style.float = oldImgs[i].style.float
						}

						if(oldImgs[i].style.width != '') {
							newImgs[i].style.width = oldImgs[i].style.width
						}


						if (oldImgs[i].className.indexOf('description-image-border') > -1) {
							newImgs[i].classList.add('description-image-border')
						}


					}



					this.countUpdateContent++
				}

			}
		},
		created() {
			document.addEventListener('click', (e) => this.checkTag(e));
		},


		data() {
			return {
				countUpdateContent: 0,
				article: '',
				activeElement: '',
				findFiles: true,
				sizeValue: '',
				sizeMenuActive: false,
				images: [],

				editor: new Editor({

					extensions: [
					new Blockquote(),
					new BulletList(),
					new CodeBlock(),
					new HardBreak(),
					new Heading({ levels: [1, 2, 3] }),
					new HorizontalRule(),
					new ListItem(),
					new OrderedList(),
					new TodoItem(),
					new Image(),
					new TodoList(),
					new Bold(),
					new Code(),
					new Italic(),
					new Link(),
					new Strike(),
					new Underline(),
					new History(),

					new Table(),
					new TableHeader(),
					new TableCell(),
					new TableRow(),


					],

					content: this.contentt,

					onUpdate: ({  getHTML }) => {
						var editorHtml = getHTML() 

						var el = document.getElementsByClassName('ProseMirror')
						var imgs = el[0].getElementsByTagName('img')

						if(imgs) {
							for (var i = imgs.length - 1; i >= 0; i--) {
								imgs[i]
								var outerHTML = imgs[i].outerHTML

								var testImgTag = outerHTML.split(' contenteditable="false" ')[0];
								testImgTag = testImgTag + '>'

								editorHtml = editorHtml.replace(testImgTag, outerHTML);

								var outerHTML = imgs[i].outerHTML

								var testImgTag = outerHTML.split(' contenteditable="false" ')[0];
								testImgTag = testImgTag + '>'

								editorHtml = editorHtml.replace(testImgTag, outerHTML);

								
							}
							
						}
						


						this.article = editorHtml
						// return false;
						// this.images[] = 
						// alert(this.article)

						// var el = document.getElementsByClassName('ProseMirror').innerHtml('wdwdwdwdwd')
						// this.article = imgs[0]


						this.exportContent()






					},
				}),
				json: 'Update content to see changes',
				linkUrl: null,
				linkMenuIsActive: false,


			}
		},
		components: {
			EditorContent,
			EditorMenuBar,
			EditorMenuBubble,
			Editor,



		},
		methods: {
			changeBanner(path) {
				this.image = path
			},
			countChars: function(str) {
				return str.length
			},
			checkTag(e) {

				if(e.target.tagName == 'IMG') {
					e.preventDefault()

					this.activeElement = e.target

				}

			},
			showLinkMenu(attrs) {
				this.linkUrl = attrs.href
				this.linkMenuIsActive = true
				this.$nextTick(() => {
					this.$refs.linkInput.focus()
				})
			},
			hideLinkMenu() {
				this.linkUrl = null
				this.linkMenuIsActive = false
			},
			setLinkUrl(command, url) {
				command({ href: url })
				this.hideLinkMenu()
				this.editor.focus()
			},
			changeSizeImage() {
				this.activeElement.style.width = this.sizeValue
				this.sizeMenuActive = false

				this.exportContent()
			},
			customEditorCss(key,value) {

				
				key == 'float' && this.activeElement.style.float != value ? this.activeElement.style.float = value : this.activeElement.style.float = ''
				

			},
			customEditorClass(cl) {
				this.activeElement.classList.add(cl)
				
				this.exportContent()
			},
			
			setContent(data) {
				this.editor.setContent(data)
			},

			exportContent(data) {
				var content = document.getElementsByClassName('ProseMirror')[0].innerHTML
				this.article = content.replace('ProseMirror-selectednode', '')
				console.log(this.article)
					// newImgs = newImgs[0].getElementsByTagName('img')
				// this.editor.setContent(data)
				if(this.article == '<p></p>') {
					this.$emit('exportContent', '');
				} else {

					this.$emit('exportContent', this.article);
				}

			},
			removeClassFromHtml(cl) {
				var el = document.getElementsByClassName('ProseMirror-selectednode')


				for (var i = el.length - 1; i >= 0; i--) {

					el[i].classList.remove(cl)
				}


			}


			

		},
	}

</script>
<style scoped>

@import url(https://tiptap.scrumpy.io/assets/css/app.dc1964fb5712252b7e53.css);

/*TABLE*/
.editor__content tr{
	background-color: #f9f9f9!important;
}


.editor {
	max-width: 100%!important;
}
.toolbar {
}


img {
	max-width: 50%!important;
	text-align: left;
}
.ProseMirror:focus {
	outline: none!important;
}
.ProseMirror {
	outline: none!important;
}
.button-create {
	border-radius: 19px;
	padding: 4px 10px 6px;
	font-weight: 500;
	font-size: 14px;
	margin-left: 15px;
	border: 2px solid #1473e6;
	background: #1473e6 !important;
	color: #fff;
}
.menubar__button span {
	color:#333;
}
.menubar__button {
	font-weight: 300;
	background: none;
	border: none;
	color: #fff;
	border-radius: 3px;
}
.menubar__button i {
	padding: 5px;
	font-size: 11px;
}
.menubar {
}
.is-active {
	background: #ddd;
}

.editor {
	margin-right: 20px; 
	min-height:360px;
}
.menububble{width: 400px;position:absolute;display:-webkit-box;display:-ms-flexbox;display:block;z-index:20;margin-left:100px;background:#44536a;border-radius:5px;padding:.3rem;margin-bottom:.5rem;-webkit-transform:translateX(-50%);-ms-transform:translateX(-50%);transform:translateX(-50%);visibility:hidden;opacity:0;-webkit-transition:opacity .2s,visibility .2s;transition:opacity .2s,visibility .2s;}
.menububble.is-active{opacity:1;visibility:visible;}
.menububble__button{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;background:rgba(0,0,0,0);border:0;color:#fff;padding:.2rem .5rem;margin-right:.2rem;border-radius:3px;cursor:pointer;}
.menububble__button:last-child{margin-right:0;}
.menububble__button:hover{background-color:hsla(0,0%,100%,.1);}
/*! CSS Used from: http://localhost:3000/css/create.css */
.fa{display:inline-block;font:normal normal normal 14px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;}
a:hover{text-decoration:none;color:#fff}
li{list-style:none;font-size:15px;}
.ml0{margin-left:0;}
ul{padding:0;}
.navigation-create{border-left:1px solid #e8e8e8;padding-right:0;}
.content-create-main-menu{    width: 90%;
	float: left;
	height: 90vh;
	padding: 25px 0;}
	.content-create-work-child-menu{width:10%;float:right;border-left:1px solid #e8e8e8;height:100%;}
	.content-create-work-child-menu-ul{text-align:center;}
	.content-create-work-child-menu-ul li{margin-top:10px;}
	.icon-a{padding:6px 6px;font-size:15px;color:#707070;border-radius:2px;}
	.icon-a:hover{background-color:#e1e1e1;border-color:#e1e1e1;color:#777; cursor: pointer}
	#content{width:100%;height:91vh;overflow:auto;padding-right:0;max-width: 80%!important}
	.table-info-view{
		display: block!important;
		width: 100%;
		height: 75vh;
		overflow: auto;
		padding-right: 15px;
	}
	.table span{flex-direction:row;width:100%;color:#747989;align-items:center;font-size:11px;letter-spacing:.666px;}
	.table{border-bottom:1px solid #eaeaea;margin-bottom:0;}
	.active{background-color:rgba(44,44,44,.06);}

	.content-place{padding:20px 10px;}


	.empty-folder{text-align:center;}
	.empty-folder img{width:99%;}
	.content-empty-folder h3{font-size:28px;font-weight:300;line-height:1.3;color:#707070;}
	.content-empty-folder p{font-size:14px;font-weight:300;line-height:1.3;color:#707070;}
	/* ************* FORM ********************/
	select {
		display: block;
		font-size: 11px;
		color: rgb(193, 193, 193);
		display: block;
		width: 100%;
		font-size: 13px;
		height: 34px;
		line-height: 10px;
		border-width: 1px 0px;
		border-top: 1px solid transparent;
		border-bottom: 1px solid rgb(226, 226, 226);
		outline: none;
		color: #777;
		background:none;
		border: 1px solid #d3dae4;
		outline: none;
		border-radius: 3px;
	}
	option {
		display: block;
		width: 100%;
		font-size: 13px;
		height: 34px;
		line-height: 10px;
		border-width: 1px 0px;
		border-top: 1px solid transparent;
		border-bottom: 1px solid rgb(226, 226, 226);
		outline: none;
	}
	.form-template{padding:0 2%;}
	.input-div{margin-bottom:30px;     width: 100%;
		display: inline-block;}
		.input{display: block;
			width: 100%;
			font-size: 13px;
			height: 34px;
			border-width: 1px 0px;
			border: 1px solid transparent;
			border: 1px solid #d3dae4;
			outline: none;
			border-radius: 3px;}
			.textarea-div {
				width: 100%;
				margin-bottom:30px; 

			}
			.textarea{
				display: block;
				width: 100%;
				font-size: 13px;
				height: auto;
				min-height: 100px;
				border-width: 1px 0px;
				border: 1px solid #d3dae4;
				outline: none;
				border-radius: 3px;}
				.footer-input{display:block;font-size:11px;color:rgb(193, 193, 193);}
				.success-button {
					margin-left: 0!important;
					width: 50%;
				}
				.success-button.active-success-button {
					border: 2px solid #1473e6;
					background: #1473e6 !important;
					color: #fff;
					border-radius: 19px;
					padding: 4px 10px 6px;
					font-weight: 500;
					font-size: 14px;
					margin-left: 15px;
				}
				.footer-info {
					text-align: right;
					border-top: 1px solid #ddd;
					padding-top: 13px!important;
				}

				/********* Переключатель *********/
				.power {
					display: table;
					cursor: pointer;
				}
				.power input {
					display: none;
				}
				.power input + div {
					position: relative;
					overflow: hidden;
					background: #EB2C59;
					border-radius: 50%;
					padding: 18px;
					transition: transform 0.4s ease;
					filter: drop-shadow(0 4px 6px rgba(235, 44, 89, 0.3));
				}
				.power input + div:before {
					content: "";
					width: 4px;
					height: 14px;
					border-radius: 2px;
					background: #fff;
					position: absolute;
					left: 50%;
					z-index: 2;
					margin: 0 0 0 -2px;
					top: 18px;
					opacity: 1;
					transform: scaleY(1) translate(0, 2px);
					transition: opacity 0.4s ease 0.1s, transform 0.9s ease 0.4s;
				}
				.power input + div:after {
					content: "";
					position: absolute;
					right: 0;
					bottom: 0;
					width: 200%;
					height: 200%;
					border-radius: 50%;
					background: #21E76E;
					transform: translate(100%, 100%);
					transform-origin: right bottom;
					transition: transform 0.8s ease;
				}
				.power input + div svg {
					width: 36px;
					height: 36px;
					fill: none;
					display: block;
					stroke: #fff;
					position: relative;
					z-index: 2;
					stroke-width: 5;
					stroke-linecap: round;
					stroke-dasharray: 84;
					stroke-dashoffset: 160;
					transform: translate3d(0, 0, 0);
					transition: stroke-dasharray 0.6s ease 0s, stroke-dashoffset 0.7s ease 0s;
				}
				.power input + div:active {
					transform: scale(0.96);
				}
				.power input:checked + div {
					filter: drop-shadow(0 4px 6px rgba(33, 231, 110, 0.3));
				}
				.power input:checked + div svg {
					stroke-dasharray: 120;
					stroke-dashoffset: 133;
					transition: stroke-dasharray 0.6s ease 0.45s, stroke-dashoffset 0.7s cubic-bezier(0.94, -0.1, 0.1, 1.2) 0.2s;
				}
				.power input:checked + div:before {
					transform: scaleY(0) translate(0, 7px);
					transition: opacity 0.4s ease 0s, transform 0.6s ease 0.3s;
				}
				.power input:checked + div:after {
					transform: translate(40%, 40%);
				}

				body {
					min-height: 100vh;
					font-family: Roboto, Arial;
					color: #ADAFB6;
					display: flex;
					justify-content: center;
					align-items: center;
				}
				body .dribbble {
					position: fixed;
					display: block;
					right: 20px;
					bottom: 20px;
					opacity: 0.5;
					transition: all 0.4s ease;
				}
				body .dribbble:hover {
					opacity: 1;
				}
				body .dribbble img {
					display: block;
					height: 36px;
				}


			</style>	


// WEBPACK FOOTER //
// src/components/app_modules/Editor.vue